import spacetime from 'spacetime';

import { IKnmListFilterParams } from 'APIPackage/KnmListModule/interfaces/IKnmListFilterParams';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { IDictionarySupervisionTypeSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySupervisionTypeSelectOption';
import { IDictionaryKnoOrganizationSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryKnoOrganizationSelectOption';
import { PlanStatusEnum } from 'APIPackage/PlanListModule/enums/PlanStatusEnum';
import { KnmVersionsEnum } from 'APIPackage/KnmModule/enums/KnmVersionsEnum';

const KNM_TYPE_WAITING_CARRY_OUT_STATUS_ID = 5;
const KNM_TYPE_CARRIED_OUT_STATUS_ID = 6;
const KNM_PP_TYPE_ID = 4;

export const getPlanKnmFilter = (
  startDate?: string,
  supervisionTypePm?: IDictionarySupervisionTypeSelectOption,
  knoOrganizationPm?: IDictionaryKnoOrganizationSelectOption,
  inn?: string,
  ogrn?: string,
  organizationName?: string,
  erpId?: string,
): IKnmListFilterParams => {
  const parsedDate = spacetime(formatDate({ date: startDate || '', dateFormat: SYSTEM_DATE_FORMAT_FNS }));
  const year = parsedDate.year();

  return {
    knmTypeIds: [KNM_PP_TYPE_ID],
    statusIds: [KNM_TYPE_WAITING_CARRY_OUT_STATUS_ID, KNM_TYPE_CARRIED_OUT_STATUS_ID],
    erknmPlanStatuses: [PlanStatusEnum.APPROVED],
    includeDomainChild: false,
    ignoreKno: false,
    includeChildKno: false,
    version: KnmVersionsEnum.ERKNM,
    supervisionTypeId: supervisionTypePm?.code,
    years: [year],
    subjectInn: inn,
    objectOgrn: ogrn,
    subjectOrgName: organizationName,
    controllingOrganizationIds: knoOrganizationPm?.id ? [knoOrganizationPm.id] : undefined,
    erpId,
  };
};
